<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, url } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      pbxUrl: '',
      phoneNumber: '',
      webhookSecret: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    pbxUrl: { required, url },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const threeCxChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName?.trim(),
            channel: {
              type: 'three_cx',
              pbx_url: this.pbxUrl,
              phone_number: this.phoneNumber || null,
              webhook_secret: this.webhookSecret || null,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: threeCxChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.THREE_CX.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.THREE_CX.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.THREE_CX.DESC')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.THREE_CX.CHANNEL_NAME.LABEL') }}
          <input
            v-model="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.THREE_CX.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.THREE_CX.CHANNEL_NAME.ERROR') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.pbxUrl.$error }">
          {{ $t('INBOX_MGMT.ADD.THREE_CX.PBX_URL.LABEL') }}
          <input
            v-model="pbxUrl"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.THREE_CX.PBX_URL.PLACEHOLDER')"
            @blur="v$.pbxUrl.$touch"
          />
          <span v-if="v$.pbxUrl.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.THREE_CX.PBX_URL.ERROR') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label>
          {{ $t('INBOX_MGMT.ADD.THREE_CX.PHONE_NUMBER.LABEL') }}
          <input
            v-model="phoneNumber"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.THREE_CX.PHONE_NUMBER.PLACEHOLDER')
            "
          />
          <span class="text-xs text-n-slate-11">
            {{ $t('INBOX_MGMT.ADD.THREE_CX.PHONE_NUMBER.SUBTITLE') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label>
          {{ $t('INBOX_MGMT.ADD.THREE_CX.WEBHOOK_SECRET.LABEL') }}
          <input
            v-model="webhookSecret"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.THREE_CX.WEBHOOK_SECRET.PLACEHOLDER')
            "
          />
          <span class="text-xs text-n-slate-11">
            {{ $t('INBOX_MGMT.ADD.THREE_CX.WEBHOOK_SECRET.SUBTITLE') }}
          </span>
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.THREE_CX.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
